// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".photos[data-v-2edc1f63]{display:grid;width:100%;grid-template-columns:repeat(6,1fr);gap:24px;row-gap:24px}", ""]);
// Exports
module.exports = exports;
